import { useEffect, useMemo, useRef, useState } from 'react';

import { useTmpStorageContext } from '#/contexts/TmpStorageContext';

export function useListingApplicationTemporaryStorageSubmission() {
  const formRef = useRef<HTMLFormElement>(null);

  const [temporaryStorageSubmitted, setTemporaryStorageSubmitted] =
    useState(false);

  const { temporaryStorage } = useTmpStorageContext();

  const temporaryStorageInitialValues = useMemo(
    () => temporaryStorage?.initialValues ?? {},
    [temporaryStorage?.initialValues],
  );

  useEffect(() => {
    let timer: number | null = null;
    if (
      temporaryStorageInitialValues &&
      // requestedAttachmentsHash is always there
      Object.keys(temporaryStorageInitialValues).length > 1 &&
      !temporaryStorageSubmitted &&
      formRef.current
    ) {
      timer = window.setTimeout(() => {
        setTemporaryStorageSubmitted(true);
        formRef.current?.dispatchEvent(new Event('submit', { bubbles: true }));
      }, 0);
    }

    return () => {
      if (!timer) return;
      window.clearTimeout(timer);
    };
  }, [
    temporaryStorage,
    temporaryStorageSubmitted,
    temporaryStorageInitialValues,
    formRef,
  ]);

  return { formRef, temporaryStorageInitialValues };
}
